@if (loading) {
  <app-loader></app-loader>
}
<div class="row mb-3">
  <div class="col-12 col-lg-6">
    <app-dynamic-breadcrumb [bgColor]="'transparent'" [fontSize]="'14px'"
    [lastLinkColor]="'rgba(196, 196, 205, 0.42)'" [fontColor]="'#c4c4cd'"></app-dynamic-breadcrumb>
  </div>
  <div class="col-12 col-lg-6 text-left text-lg-right">
    <button class="btn btn-primary-ey btn-icon small-font mr-2 hvr-shrink" type="button" (click)="refreshList()">
      <div class="icon-container"><i class="fas fa-sync-alt"></i></div><span>Refresh</span>
    </button>
    <button class="btn btn-primary-ey btn-icon small-font hvr-shrink" type="button" (click)="openBundlingForm()">
      <div class="icon-container"><i class="fas fa-play"></i></div><span>Start New Bundling</span>
    </button>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="data-ing-scroll">
      <p-table #dting [value]="bundleList" [paginator]="true" [rows]="9" class="table-irr" [columns]="headerCols"
        [scrollable]="true" [scrollHeight]="'calc(100vh - 200px'">
        <ng-template pTemplate="paginatorleft">
          <button class="btn btn-clear-filter hvr-shrink" type="button"
            (click)="dting.reset();clearFilters();">
            <span><i class="fas fa-times mr-1"></i> Clear Filters</span>
          </button>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field">
                {{col.header}}
                @if (col.field !='status' && col.field != 'generatedFileName') {
                  <p-sortIcon
                    [field]="col.field" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                  ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                }
              </th>
            }
            <th>Actions</th>
            <th style="width: 70px;"></th>
          </tr>
          <tr>
            @for (col of columns; track col) {
              <th>
                @if (col.field !='status' && col.field != 'generatedFileName' && col.field != 'createdDate') {
                  <input
                    type="text" class="w-100" placeholder="Filter Text"
                    [value]="dting.filters && dting.filters[col.field] ? dting.filters[col.field].value: ''"
                    (input)="dting.filter($event.target.value, col.field, 'contains')">
                }
                @if (col.field =='createdDate') {
                  <p-datepicker [(ngModel)]="createdDateFilters" #rdFilter
                    selectionMode="range" [showIcon]="true" dateFormat="dd/mm/yy" [readonlyInput]="true"
                    placeholder="Select a range" [monthNavigator]="true"
                    [yearNavigator]="true" yearRange="{{yearRange}}"
                    (ngModelChange)="dting.filter(createdDateFilters, col.field, 'dateRangeFilter')"
                    (onSelect)="closeDateRangeFilter(rdFilter, createdDateFilters)">
                  </p-datepicker>
                }
              </th>
            }
            <th></th>
            <th style="width: 70px;"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr>
            <td>{{rowData.bundleName}}</td>
            <td>{{rowData.bundleTypeName}}</td>
            <td>{{rowData.reportPackId}}</td>
            <td>{{rowData.reportPackName}}</td>

            <!-- <td *ngIf="!rowData.generatedFileName"> </td> -->
            <td>{{rowData.createdBy}}</td>
            <td>{{rowData.createdDate | date: 'dd/MM/yyyy'}}</td>
            <td>
              @if (rowData.actions && rowData.actions.length > 0) {
                <div
                  class="status-progress d-flex align-items-center position-relative" style="float:left">
                  @for (action of rowData.actions; track action) {
                    <div
                      class="d-flex align-items-center justify-content-center flex-column mr-3 status-progress-container "
                                    [ngClass]="{'completed': action.status === 'Completed',
                                            'failed':action.status === 'Failed',
                                            'in-progress':action.status === 'In Progress',
                                            'not-started': action.status === 'Not Started'}" container="body"
                      ngbTooltip="{{action.actionName}}">
                      <div class="circle-status d-flex align-items-center justify-content-center">
                        @if (action.actionName == 'Report Bundling') {
                          <i
                          class="fas fa-clipboard-check fa-lg"></i>
                        }
                        @if (action.actionName == 'Email') {
                          <i
                          class="fas fa-external-link-alt fa-lg"></i>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </td>
            <td><button class="btn-table-icon hvr-shrink" type="button" (click)="viewReportBundle(rowData)"
              ngbTooltip="View" container="body" tooltipClass="reporting-tooltip">
              <i class="fas fa-eye"></i>
            </button>
            @if (rowData.generatedFileName) {
              <button class="btn-table-icon hvr-shrink" type="button"  (click)="openModal(promptContent, rowData)"
                ngbTooltip="Download Generated File" container="body" tooltipClass="reporting-tooltip">
                <i class="fas fa-download"></i>
              </button>
            }
          </td>
          <td style="width: 70px;">@if (rowData.actions[0].status=="Failed") {
            <i
              class="fas fa-exclamation-triangle hvr-shrink failed-icon ml-3 fa-lg" placement="left"
            ngbTooltip="{{rowData.actions[0].logMessage}}" container="body"></i>
          }</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
</div>

<ng-template #promptContent>
  <div class=" modal-header">
    <h5 class="modal-title d-flex align-items-center m-0 w-100">
      Download Generated Report<i class="fas fa-times ml-auto cursor-pointer" aria-label="Close" (click)="closeModal();"></i>
    </h5>
  </div>
  <div class="modal-body description-content text-center">
    <div>
      @if (isPartialUpload) {
        <p>The selected report pack has underwent partial upload / file edit, Do you want to reprepare data or download existing generated file?</p>
      }
      @if (!isPartialUpload) {
        <p>File is ready to Download!</p>
      }
    </div>
  </div>
  <div class="modal-footer">
    <div class="float-right">
      @if (isPartialUpload) {
        <button class="btn btn-modal-pos small-font hvr-shrink" (click)="rePrepareData()" type="button">
          <span>Re-Prepare Data</span>
        </button>
      }
      <button class="btn btn-modal-pos small-font hvr-shrink" (click)="downloadGeneratedFile(selectedRow.generatedFileName)" type="button">
        <span>Download Generated File</span>
      </button>
    </div>
  </div>
</ng-template>